module.exports = {"522302001":"东湖街道","522302002":"城南街道","522302003":"真武山街道","522302004":"城北街道","522302005":"陆官街道","522302006":"薏品田园街道","522302101":"屯脚镇","522302102":"巴铃镇","522302103":"百德镇","522302104":"雨樟镇","522302105":"潘家庄镇","522302106":"回龙镇","522302107":"下山镇","522302108":"新龙场镇","522302109":"大山镇","522302110":"马马崖镇","522302111":"波阳镇","522302200":"鲁础营回族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522302.json
// module id = 2636
// module chunks = 0